"use client";

import NextLink from "next/link";
import { usePathname } from "next/navigation";

import { usePageMessage } from "#app/_ui/components/errors/use-page-message";
import { UnauthorizedFooter } from "#app/_ui/components/footers/UnauthorizedFooter";
import { PageOutageAlertBanner } from "#app/_ui/components/outages/page-outage-alert-banner";
import { PageOutageMain } from "#app/_ui/components/outages/page-outage-main";
import { Banner } from "#ui/banner";
import { Container } from "#ui/container";
import { HeaderWithSlots } from "#ui/header";
import { Icon } from "#ui/icon";
import { LandmarkLink } from "#ui/landmark-link";
import { LinkButton } from "#ui/link";
import { Logo } from "#ui/logo";
import { Main } from "#ui/main";

export default function Layout({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  const dataPageMessage = usePageMessage({ path: pathname });

  return (
    <>
      <LandmarkLink type="trigger" slug="main" label="main content" />
      <LandmarkLink type="trigger" slug="footer" label="footer content" />
      <HeaderWithSlots
        layout="mobileOnly"
        slot0={
          <NextLink href="/">
            {/* TODO: Convert dual logos to one responsive logo */}
            <Logo layout="mark-only" size="xs" className="sm:hidden" />
            <Logo layout="mark-and-word" size="xs" className="max-sm:hidden" />
          </NextLink>
        }
        slot1={
          <LinkButton variant="link" href="/sign-in">
            <Icon name="ms-navigate-prev" />
            Back to sign in
          </LinkButton>
        }
      />
      <PageOutageAlertBanner data={dataPageMessage} />
      <LandmarkLink type="target" slug="main" label="main content" />
      <PageOutageMain data={dataPageMessage}>
        <Main>
          <Banner />
          <Container>{children}</Container>
        </Main>
      </PageOutageMain>
      <LandmarkLink type="target" slug="footer" label="footer content" />
      <UnauthorizedFooter />
    </>
  );
}
